






import Vue from 'vue';

export default Vue.extend({
  name: 'PasswordValidationIcon',
  props: {
    status: {
      type: Boolean,
      required: false,
      default: null,
    },
  },
});
